import Venues from "../components/Dashboard/Venue/Venues";
import VenueDetails from "../components/Dashboard/Venue/VenueDetails";
import Venue from "../components/Dashboard/Venue/Venue";

const venueRoutes = [
    {
        path: "venues",
        component: Venues,
        meta: {
            required: true,
            roles: ["PanelUser", "PanelVenueUser"],
        },
        name: "Venues",
    },
    {
        path: "venue",
        component: Venue,
        meta: {
            required: true,
            roles: ["PanelUser", "PanelVenueUser"],
        },
        name: "Venue",
    },
    {
        path: "venue/:id",
        component: VenueDetails,
        meta: {
            required: true,
            roles: ["PanelUser", "PanelVenueUser"],
        },
        name: "VenueDetails",
    },
]

export default venueRoutes;